import IPromotionRepository from 'domain/interfaces/repositories/IPromotionRepository'

export const updatePromotionSetDelegateCommand = (
  repository: IPromotionRepository,
  promotionId: string,
  representativeId: string,
) => {
  return repository.updatePromotionSetDelegate(promotionId, representativeId)
}
